export const loadScript = async (srcOrSrcs) => {
  const srcs = [].concat(srcOrSrcs)

  return Promise.all(
    srcs.map((src) => {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = src
      document.body.appendChild(script)

      return new Promise((resolve, reject) => {
        script.onload = resolve
        script.onerror = reject
      })
    }),
  )
}

const SNAKE_CASE_REGEXP = /[A-Z]/g
export const toSnakeCase = function (name, separator) {
  if (separator == null) {
    separator = '_'
  }
  return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {
    letter = letter.toLowerCase()
    if (pos) {
      return separator + letter
    }
    return letter
  })
}

export const environment = () => {
  if (window.location.port !== '') {
    return 'development'
  }

  if (window.location.pathname.includes('stage')) {
    return 'staging'
  }

  return 'live'
}

export const liveEnvironment = function () {
  return environment() === 'live'
}

export const devEnvironment = function () {
  return environment() === 'development'
}

export const stagingEnvironment = function () {
  return environment() === 'staging'
}
